(function () {
  // Several sections include this script; run it once so each click toggles once.
  if (window.dilmasWishlistReady) return;
  window.dilmasWishlistReady = true;

  var STORAGE_KEY = 'dilmas_wishlist';

  function readWishlist() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(ids) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    } catch (e) {
      /* storage unavailable (private mode, blocked, etc.) — fail silently */
    }
  }

  function syncButton(button, wishlist) {
    var id = button.getAttribute('data-product-id');
    var liked = wishlist.indexOf(id) !== -1;
    button.classList.toggle('is-liked', liked);
    button.setAttribute('aria-pressed', liked ? 'true' : 'false');
  }

  function syncAll() {
    var wishlist = readWishlist();
    document.querySelectorAll('[data-dilmas-wishlist-toggle]').forEach(function (button) {
      syncButton(button, wishlist);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-dilmas-wishlist-toggle]');
    if (!button) return;

    event.preventDefault();
    var id = button.getAttribute('data-product-id');
    var wishlist = readWishlist();
    var index = wishlist.indexOf(id);

    if (index === -1) {
      wishlist.push(id);
    } else {
      wishlist.splice(index, 1);
    }

    writeWishlist(wishlist);
    syncAll();
  });

  // Filtering, sorting and quick views re-render cards; restore their hearts.
  var syncQueued = false;
  function queueSync() {
    if (syncQueued) return;
    syncQueued = true;
    requestAnimationFrame(function () {
      syncQueued = false;
      syncAll();
    });
  }

  function start() {
    syncAll();
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          queueSync();
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
